import { type FC } from 'react';

import { Message } from '#packages/web/foundations/feedback/message';

import { MessagePage, type MessagePageProps } from './message-page';

export type ErrorPageProps = MessagePageProps;

export const ErrorPage: FC<ErrorPageProps> = ({
  image = (
    <img
      src="https://placehold.co/200x100/dddddd/999999"
      alt="An unexpected error occurred."
      style={{ display: 'flex' }}
    />
  ),
  message = <Message>An unexpected error occurred.</Message>,

  ...props
}) => <MessagePage image={image} message={message} {...props} />;
